module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ads-query"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_vm._l((_vm.categories), function(category, index) {
    return _c('div', [_c('label', [_vm._v(_vm._s(_vm.translateColumn(category.columnName)))]), _vm._v(" "), _c('MultiSelect', {
      attrs: {
        "allOption": true,
        "many": "selected",
        "options": category.options,
        "value": _vm.selectedCategories[index].options
      },
      on: {
        "update:value": function () {
          var args = [], len = arguments.length;
          while ( len-- ) args[ len ] = arguments[ len ];

          return _vm.updateCategories.apply(void 0, [ index ].concat( args ));
    }
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "check-box",
    on: {
      "click": _vm.toggleAggregateUrls
    }
  }, [_c('span', [(_vm.aggregateUrls) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.aggregateUrls) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("check_box_outline_blank")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n().aggregateUrls))])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5031e5e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ads/AdsQuery.vue
// module id = 445
// module chunks = 0